var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpBox",
    { staticClass: "overflow-hidden h-100", attrs: { direction: "column" } },
    [
      _c("JobProgress", { attrs: { item: _vm.item } }),
      _vm._v(" "),
      _c(
        "ItpBox",
        { attrs: { direction: "row" } },
        [
          _vm.item.start_time
            ? _c("ItpText", {
                staticClass: "mr-2",
                attrs: {
                  muted: "",
                  text: _vm._f("pgettext")("Start time", "Job")
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.item.start_time
            ? _c("ItpText", { staticClass: "mr-4", attrs: { strong: "" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("datetime")(_vm.item.start_time)) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.end_time
            ? _c("ItpText", {
                staticClass: "mr-2",
                attrs: {
                  muted: "",
                  text: _vm._f("pgettext")("End time", "Job")
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.item.end_time
            ? _c("ItpText", { staticClass: "mr-2", attrs: { strong: "" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("datetime")(_vm.item.end_time)) +
                    "\n    "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.result_text && _vm.result_text != _vm.details
        ? _c("ItpAlert", { attrs: { show: "" } }, [
            _c("span", [
              _vm._v("\n      " + _vm._s(_vm.result_text) + "\n    ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.details
        ? _c("DIV", { staticClass: "border mt-2 overflow-auto" }, [
            _c(
              "pre",
              {
                staticClass: "m-0 p-3 h-100 w-100",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.evh_6917646200545441_clickStop($event, {})
                  }
                }
              },
              [_vm._v(_vm._s(_vm.details))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.item.files && _vm.item.files.length
        ? _c("JobFiles", { attrs: { item: _vm.item } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }